export default {"src":"/_next/static/media/FR.2a5486a9.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};